import Vue from "vue";

Vue.filter("convertISODateToDE", function(value) {
    if (value) {
        // 2023-06-12T00:00:00+00:00
        const items = value.split('T')
        return items[0].split('-').reverse().join('.')
    }
});